import { Block } from 'slate'

const schema = {
	document: {
		last: {
			type: 'paragraph',
			text: /$\w*^/,
		},
		nodes: [
			{
				match: [
					{ type: 'paragraph' },
					{ type: 'heading-two' },
					{ type: 'heading-three' },
					{ type: 'block-quote' },
					{ type: 'bulleted-list' },
					{ type: 'numbered-list' },
					{ type: 'list-item' },
					{ type: 'link' },
					{ type: 'hr' },
					{ type: 'file' },
					{ type: 'image' },
					{ type: 'youtube' },
					{ type: 'vimeo' },
					{ type: 'draw' },
					{ type: 'figma' },
					{ type: 'gist' },
					{ type: 'codepen' },
					{ type: 'table-of-contents' },
					{ type: 'page-index' },
					{ type: 'code_block' },
					{ type: 'code_line' },
					{ type: 'hint' },
					{ type: 'heading-placeholder' },
					{ type: 'paragraph-placeholder' },
				],
				min: 1,
			},
		],
		normalize: (editor, error) => {
			switch (error.code) {
				// case 'child_type_invalid': {
				// 	if (error.child.type === 'ul_list') {
				// 		editor.setNodeByKey(error.child.key, { type: 'bulleted-list' })
				// 	} else if (error.child.type === 'ol_list') {
				// 		editor.setNodeByKey(error.child.key, { type: 'numbered-list' })
				// 	}

				// 	break
				// }
				case 'last_child_text_invalid': {
					const paragraph = Block.create('paragraph')

					return editor.insertNodeByKey(
						error.node.key,
						error.node.nodes.size,
						paragraph
					)
				}
				case 'last_child_type_invalid': {
					const paragraph = Block.create('paragraph')

					return editor.insertNodeByKey(
						error.node.key,
						error.node.nodes.size,
						paragraph
					)
				}
				default:
			}

			return null
		},
	},
	inlines: {},
	blocks: {
		'bulleted-list': {
			nodes: [
				{
					match: [
						{ type: 'bulleted-list' },
						{ type: 'numbered-list' },
						{ type: 'list-item' },
						{ type: 'paragraph' },
						{ objects: ['text'] },
					],
				},
			],
			normalize: (editor, error) => {
				switch (error.code) {
					case 'child_type_invalid': {
						return editor.setNodeByKey(error.child.key, {
							type: 'list-item',
						})
					}
					default:
				}

				return null
			},
		},
		'numbered-list': {
			nodes: [
				{
					match: [
						{ type: 'bulleted-list' },
						{ type: 'numbered-list' },
						{ type: 'list-item' },
						{ type: 'paragraph' },
						{ objects: ['text'] },
					],
				},
			],
			normalize: (editor, error) => {
				switch (error.code) {
					case 'child_type_invalid': {
						return editor.setNodeByKey(error.child.key, {
							type: 'list-item',
						})
					}
					default:
				}

				return null
			},
		},
		// Old data
		list_item: {
			parent: [{ type: 'bulleted-list' }, { type: 'numbered-list' }],
			normalize: (editor, error) => {
				switch (error.code) {
					case 'parent_type_invalid': {
						return editor.setNodeByKey(error.node.key, {
							type: 'list-item',
						})
					}

					default:
				}

				return null
			},
		},
		ul_list: {
			nodes: [
				{
					match: { type: 'list-item' },
					min: 1,
				},
				{
					match: [
						{ type: 'bulleted-list' },
						{ type: 'numbered-list' },
						{ type: 'paragraph' },
						{ objects: ['text'] },
					],
					min: 0,
				},
			],
			normalize: (editor, error) => {
				switch (error.code) {
					case 'child_min_invalid': {
						if (error.node.type === 'ul_list') {
							editor.setNodeByKey(error.node.key, {
								type: 'bulleted-list',
							})
						}

						break
					}
					default:
				}
			},
		},
		ol_list: {
			nodes: [
				{
					match: { type: 'list-item' },
					min: 1,
				},
				{
					match: [
						{ type: 'bulleted-list' },
						{ type: 'numbered-list' },
						{ type: 'paragraph' },
						{ objects: ['text'] },
					],
					min: 0,
				},
			],
			normalize: (editor, error) => {
				switch (error.code) {
					case 'child_min_invalid': {
						if (error.node.type === 'ol_list') {
							editor.setNodeByKey(error.node.key, {
								type: 'numbered-list',
							})
						}

						break
					}
					default:
				}
			},
		},

		'heading-two': {
			nodes: [{ objects: ['text'] }],
			// marks: ['']
		},
		'heading-three': {
			nodes: [{ objects: ['text'] }],
			// marks: ['']
		},
		// hint: {
		// 	nodes: [
		// 		{ objects: ['text'] },
		// 	],
		// },
		codepen: { isVoid: true },
		gist: { isVoid: true },
		youtube: { isVoid: true },
		vimeo: { isVoid: true },
		draw: { isVoid: true },
		figma: { isVoid: true },
		image: { isVoid: true },
		file: { isVoid: true },
		hr: { isVoid: true },
		'table-of-contents': { isVoid: true },
		'page-index': { isVoid: true },
	},
}

export default schema
